(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lazy-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lazy-google-reviews')) {
    class LazyGoogleReviews extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') {
          return;
        }

        this.dataset.initialized = 'true';

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              this.load();
            }
          }, { rootMargin: '600px 0px' });

          this.observer.observe(this);
        } else {
          window.addEventListener('load', () => this.load(), { once: true });
        }
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      async load() {
        if (this.dataset.loaded === 'true') {
          return;
        }

        const template = this.querySelector(':scope > template');
        const scriptSource = this.dataset.scriptSrc;

        if (!template || !scriptSource) {
          return;
        }

        this.dataset.loaded = 'true';
        this.appendChild(template.content.cloneNode(true));
        template.remove();

        if (!window.tcvGoogleReviewsScript) {
          window.tcvGoogleReviewsScript = new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = scriptSource;
            script.async = true;
            script.addEventListener('load', resolve, { once: true });
            script.addEventListener('error', resolve, { once: true });
            document.head.appendChild(script);
          });
        }

        await window.tcvGoogleReviewsScript;
        this.setAttribute('aria-busy', 'false');
      }
    }

    customElements.define('lazy-google-reviews', LazyGoogleReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  const selector = '.shopify-section--main-collection .collection .product-list';
  const observed = new Map();
  let frame = 0;
  const schedule = () => { if (!frame) frame = requestAnimationFrame(align); };
  const observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      if (observed.get(entry.target) !== width) {
        observed.set(entry.target, width);
        schedule();
      }
    }
  });
  function align() {
    frame = 0;
    for (const list of observed.keys()) {
      if (!list.isConnected) { observer.unobserve(list); observed.delete(list); }
    }
    for (const list of document.querySelectorAll(selector)) {
      if (!observed.has(list)) {
        observed.set(list, list.getBoundingClientRect().width);
        observer.observe(list);
      }
      const items = [...list.children].filter(card => card.matches('.product-card')).map(card => ({
        card,
        title: card.querySelector('.product-card__info .product-title'),
        badge: card.querySelector('.tcv-card-condition-badge')
      }));
      for (const item of items) {
        item.title?.style.removeProperty('--tcv-row-title-height');
        item.title?.style.removeProperty('--tcv-missing-condition-space');
        item.badge?.style.removeProperty('--tcv-row-condition-height');
      }
      const rows = [];
      for (const item of items) {
        if (!item.title || !item.title.getClientRects().length || !item.title.getBoundingClientRect().height) continue;
        const top = item.card.offsetTop;
        let row = rows.find(row => Math.abs(row.top - top) < 2);
        if (!row) rows.push(row = {top, items: []});
        row.items.push(item);
      }
      const measurements = rows.map(row => ({
        items: row.items,
        titleHeight: Math.ceil(Math.max(...row.items.map(item => item.title.getBoundingClientRect().height))),
        badgeHeight: Math.ceil(Math.max(0, ...row.items.map(item => item.badge?.getBoundingClientRect().height || 0)))
      }));
      for (const row of measurements) {
        for (const item of row.items) {
          item.title.style.setProperty('--tcv-row-title-height', row.titleHeight + 'px');
          if (item.badge) {
            item.badge.style.setProperty('--tcv-row-condition-height', row.badgeHeight + 'px');
          } else if (row.badgeHeight) {
            const gap = parseFloat(getComputedStyle(item.title.parentElement).rowGap) || 0;
            item.title.style.setProperty('--tcv-missing-condition-space', (row.badgeHeight + gap) + 'px');
          }
        }
      }
    }
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true, attributes: true,
    attributeFilter: ['collection-mobile-layout', 'collection-desktop-layout']
  });
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('load', event => {
    if (event.target.matches?.(selector + ' img')) schedule();
  }, true);
  document.fonts?.ready.then(schedule);
  document.fonts?.addEventListener('loadingdone', schedule);
  schedule();
})();

  } catch(e) { console.error(e); }
})();
})();
